import React from 'react';
import './estilodashuser.css';

export default function Suporte() {
  return (
    <div className="content-page">
      <div className="content-card">
        <div className="content-page-header">
          <div>
            <h2>Contato e Suporte</h2>
            <p>
              Encontre aqui os canais oficiais para dúvidas sobre instalação, licenças, cobrança, alteração de plano e operação.
            </p>
          </div>
        </div>

        <div className="suporte-grid">
          <div className="suporte-col">
            <div className="suporte-secao">
              <h3>Atendimento</h3>
              <p>
                📱{' '}
                <a
                  href="https://wa.me/5542984241307"
                  target="_blank"
                  rel="noreferrer"
                >
                  WhatsApp: (42) 98424-1307
                </a>
              </p>
              <p>
                📧 <a href="mailto:contato@quantumtrades.com.br">contato@quantumtrades.com.br</a>
              </p>
              <p>
                📧 <a href="mailto:suporte@quantumtrades.com.br">suporte@quantumtrades.com.br</a>
              </p>
              <p>
                📺{' '}
                <a
                  href="https://www.youtube.com/@QuantumTradesBR"
                  target="_blank"
                  rel="noreferrer"
                >
                  Canal do YouTube
                </a>
              </p>
              <p>
                📨{' '}
                <a
                  href="https://t.me/QuantumTradesBr"
                  target="_blank"
                  rel="noreferrer"
                >
                  Canal no Telegram
                </a>
              </p>
              <p>
                👥{' '}
                <a
                  href="https://t.me/+tdXvf6jsLSZmZjlh"
                  target="_blank"
                  rel="noreferrer"
                >
                  Grupo Telegram VIP para assinantes
                </a>
              </p>
            </div>
          </div>

          <div className="suporte-col">
            <div className="suporte-secao">
              <h3>Quando procurar o suporte</h3>
              <ul>
                <li>Dúvidas sobre instalação do robô e templates.</li>
                <li>Problemas para cadastrar ou validar uma licença.</li>
                <li>Alteração de plano, tier ou contratação de mais slots.</li>
                <li>Divergência em pagamento ou mês de referência.</li>
                <li>Dúvidas sobre ativação da conta e acesso inicial.</li>
              </ul>
            </div>

            <div className="suporte-secao">
              <h3>Corretora recomendada</h3>
              <p>
                💹 Para operações em Forex, recomendamos a <strong>Exness</strong>.
              </p>
              <p>
                <a
                  href="https://one.exnesstrack.org/a/hkga5cflzh"
                  target="_blank"
                  rel="noreferrer"
                  style={{ fontWeight: 'bold' }}
                >
                  Clique aqui para abrir sua conta Exness
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="cliente-help-box" style={{ marginTop: 18 }}>
          <strong>Atalho útil:</strong> se você precisar alterar plano ou resolver qualquer item da sua assinatura,
          envie ao suporte seu nome, o robô/pacote contratado e o tier desejado. Isso agiliza bastante o atendimento.
        </div>
      </div>
    </div>
  );
}
